export default "__VITE_ASSET__B1HqCmG9__"